'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('contact-show', {
      url: '/contact/:id',
      template: '<contact-show></contact-show>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/portfolio/contact-show/contact-show.routes.js